import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async index(payload = {}) {
        if (!payload.accountId) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/automations', { params: payload });

        return response.data.data;
    },

    async store(payload = {}) {
        const response = await axios.post('v1/automations', payload);

        return response.data.data;
    },

    async show(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.get(`v1/automations/${id}`, { params: payload });

        return response.data.data;
    },

    async update(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.put(`v1/automations/${id}`, payload);

        return response.data.data;
    },

    async destroy(id) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.delete(`v1/automations/${id}`);

        return response.data.data;
    },
};
